<template>
  <div class='h100-40 width-100vw h-scroll'>
    <ConfigBackupTableButton @notice='notice' @transmitInput="transmitInput"></ConfigBackupTableButton>
    <ejs-treegrid ref='grid' :treeColumnIndex='index' :dataSource='nodeList' childMapping="subtasks" :allowResizing='true'
      autoCheckHierarchy="true" collapsed="true" height="640px">
      <e-columns>
        <e-column field='id' :headerText='$t("DataManagent.neid")' width='14%' showCheckbox="true" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='name' :headerText='$t("Software.td_neID")' width='8%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='displaySoftwareVersion' :headerText='$t("Topo.devSoftVersion")' width='22%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='ip' :headerText='$t("Pm.ip")' width='22%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='port' :headerText='$t("System.port")' width='22%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='createTime' :headerText='$t("Software.td_createTime")' width='11%' type='date' :format='dateFormatOptions' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-treegrid>
    <ejs-pager ref='pager' @click='request' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    <CustomDialog ref="addClientDialog" v-bind:element="addDialog.element" v-bind:styles="addDialog.styles">
      <template v-slot:dialog-content>
        <ConfigBackupFileNameOption ref="addClient" baseType="add"></ConfigBackupFileNameOption>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import ConfigBackupTableButton from './ConfigBackupTableButton.vue';
import { TreeGridPlugin, Page, Resize, RowDD } from "@syncfusion/ej2-vue-treegrid";
import ConfigBackupFileNameOption from './ConfigBackupFileNameOption.vue';
import CustomDialog from '../../components/common/CustomDialog';
import Vue from "vue";
import {EventBus} from "@/plugins/eventBus";
import socketInstance from '../../plugins/stompSock';

Vue.use(TreeGridPlugin);
let dataSource = [];
let currentMillions = 0;

export default {
  name: "configBackup",
  components: {
    ConfigBackupTableButton,
    CustomDialog,
    ConfigBackupFileNameOption,
  },
  data() {
    return {
      receiveInput: "",
      index: 0,
      dateFormatOptions: { type: 'date', format: 'yyyy-MM-dd HH:mm:ss' },
      nodeList: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageCount: 10
      },
      resdata: [],
      nodeIdArr: [],
      websocketSetting: [
        { topic: '/user/#/configBackup', clientId: 'configBackup', callback: this.websocketCallback }
      ],
      addDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'addClientDialog',
          buttonGroup: [
            {
              click: this.addDialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.addClient,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ],
          title: `${this.$t('Security.placeholder.fileName')}`
        },
        styles: {
          width: '500px',
          height: '280px',
          model: true,
          visible: false
        }
      },
    }
  },
  methods: {
    request() {
      if (this.receiveInput != "") {
        this.$refs.pager.ej2Instances.currentPage = 1
      }
      this.axios.post(`/lte/ems/topo/getPhysicalViewList`, {
        pageNo: this.$refs.pager.ej2Instances.currentPage,
        pageSize: this.$refs.pager.ej2Instances.pageSize,
        keyword: this.receiveInput
      }).then((response) => {
        if(response.data.errorCode == 'SUCCESS'){
          dataSource = response.data.resultVal.result;
          if (dataSource.length == 0) {
            this.page.totalCount = 0;
          } else {
            this.page.totalCount = response.data.resultVal.totalCount;
          }
          this.page.pageNo = response.data.resultVal.pageNo;
          this.page.pageSize = response.data.resultVal.pageSize;
          this.dataBinding(dataSource);
        }
      });
    },
    //这块有个非常grass的bug，就是如果使用<ejs-treegrid>标签时，创建节点必须创建个新{}对象去包裹，否则父子节点缩进和勾选就会出问题
    dataBinding(dataSource) {
      this.resdata = [];
      dataSource.forEach(element => {
        if(element.parentId==null&&element.typeCode==0){
          let master = this.getMaster(element);
          this.resdata.push(master);
        }
      })
      dataSource.forEach(element => {
        if(!(element.parentId==null&&element.typeCode==0)){
          if(element.typeCode==0){
            let master = this.getMaster(element);
            element = master;
          }
          if(element.parentId==null){
            this.resdata.push(this.getNewOne(element));
          }else{
            let hasCont = this.setChildren(this.resdata,element);
            //子数据存在而无父数据时列表展示（主要用于模糊搜索中的所有子任务的场景）
            if(!hasCont)
            {
              this.resdata.push(element)
            }
          }
        }
      });
      this.nodeList = this.resdata;
    },
    getMaster(element){
      let master = {};
      master.id = element.id;
      master.taskId = element.id;
      master.name = element.name;
      master.displaySoftwareVersion = "-";
      master.ip = "-";
      master.port = "-";
      master.createTime = "-";
      master.typeCode = element.typeCode;
      master.parentId = element.parentId;
      master.subtasks = [];
      return master;
    },
    setChildren(resdata,neObj){
      let hasCont = false;
      resdata.forEach(item => {
        if(item.taskId == neObj.parentId)
        {
          item.subtasks.push(this.getNewOne(neObj));
          hasCont= true;
        }else{
          if(typeof item.subtasks!= 'undefined'){
            if(this.setChildren(item.subtasks,neObj)){
              hasCont=  true;
            }
          }
        }
      })
      return hasCont;
    },
    getNewOne(element){
      let newElement = {};
      newElement.id = element.id;
      newElement.taskId = element.id;
      newElement.name = element.name;
      newElement.displaySoftwareVersion = element.displaySoftwareVersion;
      newElement.ip = element.ip;
      newElement.port = element.port;
      newElement.createTime = element.createTime;
      newElement.typeCode = element.typeCode;
      newElement.parentId = element.parentId;
      newElement.subtasks = element.subtasks
      return newElement;
    },
    notice(type) {
      switch (type) {
        case 'backup':
          this.showBackupDialog();
          break;
        case 'refresh':
          this.request();
          break;
        default:
      }
    },
    transmitInput(input) {
      this.receiveInput = input;
      this.request();
    },
    showBackupDialog() {
      const selectedRecords = this.$refs.grid.getCheckedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        return false;
      }
      this.$refs.addClientDialog.show();
    },
    addClient() {
      this.backup();
    },
    addDialogHide() {
      this.$refs.addClientDialog.clear();
      this.$refs.addClientDialog.close();
    },
    backup() {
      const selectedRecords = this.$refs.grid.getCheckedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        return false;
      }
      const This = this;
      const neIdList = [];
      const selectMultiple = true;
      const ids = This.getCheckedValsExcludeSubnet(selectMultiple);

      ids.forEach(item => {
        if (This.nodeIdArr.includes(parseInt(item))) {
          neIdList.push(item);
        }
      })
      let backupFileName = "";
      if (this.$refs.addClient.backupFileName != "") {
        backupFileName = this.$refs.addClient.backupFileName;
      } else {
        backupFileName = "NeCfgBackup";
      }
      const param = {neIdList: JSON.stringify(neIdList), backupFileName: backupFileName};
      this.$loading.showLoadding(this.$t("SubscriberIms.waitTip"));
      axios({
        method: 'post',
        url: '/lte/ems/sysmanager/configBackup',
        data:param,
        // 二进制流文件，一定要设置成blob，默认是json
        responseType: 'blob',
        timeout: 30 * 60 * 1000
      }).then(response => {
        this.$loading.hideLoadding();
        const link = document.createElement('a');
        const blob = new Blob([response.data], { type: 'application/zip' });
        let fileNames = response.headers['content-disposition'] //获取到Content-Disposition;filename
        let regFileNames = backupFileName + fileNames.match(/_[^_]+/)[0]; //文件名称  截取=后面的文件名称
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", regFileNames);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$loading.hideLoadding();
        this.addDialogHide();
      });
    },
    findNodeId() {
      const This = this;
      This.nodeIdArr = [];
      This.$axios.get('/lte/ems/auth/findNodeIdByAuth').then((response) => {
        if (response && response.status === 200) {
          This.nodeIdArr = response.data;
        }
      });
    },
    getCheckedData(selectMultiple) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getCheckedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectMultiple) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return false;
      }
      return selectedRecords;
    },
    getCheckedVals(selectMultiple) {
      const ids = [];
      const checkedData = this.getCheckedData(selectMultiple);
      for (let i = 0; i < checkedData.length; i++) {
        ids.push(checkedData[i].id);
      }
      return ids;
    },
    getCheckedValsExcludeSubnet(selectMultiple) {
      const ids = [];
      const checkedData = this.getCheckedData(selectMultiple);
      for (let i = 0; i < checkedData.length; i++) {
        if (checkedData[i].typeCode != "0") {
          ids.push(checkedData[i].id);
        }
      }
      return ids;
    },
    websocketInit() {
      socketInstance.init(this.websocketSetting);
    },
    websocketCallback(msg) {
      let currentTimeMilliseconds = Date.now();
      if (currentTimeMilliseconds - currentMillions > 1000) {
        const response = JSON.parse(msg.body);
        console.log("******websocketCallback-response:", response)
        const username = JSON.parse(sessionStorage.getItem("principal")).username;
        if (response.username == username) {
          if (response.errorCode == '16004') {
            EventBus.$emit('toast', {type: 'error', content: this.$t(response.errorString)});
          } else if (response.failList.length == 0 && response.successList.length > 0) {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
          } else if (response.failList.length > 0 && response.successList.length == 0) {
            const failList = response.failList;
            let appendInfo = "";
            failList.forEach(item => {
              appendInfo += item.neName + ", ";
            })
            EventBus.$emit('toast', {type: 'error', content: this.$t('MML.backup') + this.$t('Alarm.error') + ":" + appendInfo});
          } else if (response.failList.length > 0 && response.successList.length > 0) {
            const failList = response.failList;
            let appendInfo = "";
            failList.forEach(item => {
              appendInfo += item.neName + ", ";
            })
            EventBus.$emit('toast', {type: 'error', content: this.$t('Software.partSucc') + ", " + this.$t('DataManagent.fail') + ":" + appendInfo});
          } else {
            EventBus.$emit('toast', {type: 'error', content: This.$t('Alarm.error')});
          }
        }
        currentMillions = currentTimeMilliseconds;
      }
    },
  },
  provide: {
    treegrid: [ Page, Resize, RowDD],
  },
  mounted() {
    this.request();
    this.websocketInit();
    this.findNodeId();
  },
  beforeDestroy() {
    for (let i = 0; i < this.websocketSetting.length; i++) {
      socketInstance.stopReceiveTopicMsg(this.websocketSetting[i].clientId, this.websocketSetting[i].topic);
    }
  },
}
</script>

<style scoped>

</style>
